import { Card } from '../design-system/Card';

export function ChallanSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} padding="md" elevation={1}>
          <div className="flex animate-pulse items-start gap-3">
            <div className="h-6 w-6 rounded-md bg-slate-200 dark:bg-slate-700" />
            <div className="min-w-0 flex-1 space-y-2">
              <div className="h-4 w-3/4 rounded bg-slate-200 dark:bg-slate-700" />
              <div className="h-3 w-1/2 rounded bg-slate-200 dark:bg-slate-700" />
              <div className="flex justify-between pt-2">
                <div className="h-3 w-16 rounded bg-slate-200 dark:bg-slate-700" />
                <div className="h-3 w-12 rounded bg-slate-200 dark:bg-slate-700" />
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
